<div style="padding: 20px">
  <h4>Are you sure to unlink buyer {{data.buyer.firstName}} {{data.buyer.lastName}}?</h4>
  <div style="width: 100%; display: flex; justify-content: space-between">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="unlinkBuyer()" style="background: #be0000; color: #fff">Unlink</button>
  </div>
</div>
